import { Controller, useFormContext } from 'react-hook-form';

import 'react-datepicker/dist/react-datepicker.css';
import { useState } from 'react';
import DateRangePickerWithName from './date-range-picker';
import DateRangePickerWithShortcuts from './date-range-picker';

const customDatePickerOptions = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Tomorrow', value: 'Tomorrow' },
  { label: 'Last 7 days', value: 'Last 7 days' },
  { label: 'Last Week', value: 'Last Week' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Last Quarter', value: 'Last Quarter' },
  { label: 'Last Year', value: 'Last Year' },
  { label: 'Month to Date', value: 'Month to Date' },
  { label: 'Quarter to Date', value: 'Quarter to Date' },
  { label: 'Year to Date', value: 'Year to Date' },
];

function FormDateRangePickerWithName({ name, label, required = true, errorMessage = '', key }: any) {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [dateRange, setDateRange] = useState<[Date | undefined, Date | undefined]>([undefined, undefined]);

  const calculateDateRange = (option: string) => {
    const today = new Date();
    let startDate: Date | undefined;
    let endDate: Date | undefined;

    switch (option) {
      case 'Today':
        startDate = today;
        endDate = today;
        break;
      case 'Yesterday':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 1);
        endDate = startDate;
        break;
      case 'Tomorrow':
        startDate = new Date(today);
        startDate.setDate(today.getDate() + 1);
        endDate = startDate;
        break;
      case 'Last 7 days':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 7);
        endDate = today;
        break;
      // Add additional cases for other options
      default:
        break;
    }

    setDateRange([startDate, endDate]);
  };

  const handleOptionChange = (option: string) => {
    setSelectedOption(option);
    calculateDateRange(option);
  };

  return (
    <div>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? `${label} is required` : false,
        }}
        render={({ field }) => (
          <>
            <div>
              {/* Option Dropdown */}
              {/* <select value={selectedOption || ''} onChange={(e) => handleOptionChange(e.target.value)}>
                {customDatePickerOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select> */}
            </div>

            <DateRangePickerWithName
              label={label}
              onChange={(dates: any) => field.onChange(dates)}
              defaultValue={field.value}
              dateRange={dateRange}
              name={name}
            />
          </>
        )}
      />

      {/* Show error message if validation fails */}
      {!watch(name) && !!errors?.filters && <p style={{ color: 'red' }}>{`${label} is required`}</p>}
    </div>
  );
}

export default FormDateRangePickerWithName;
